import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonProps,
  Typography,
  styled,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { colors } from "../../../../helpers/colors";

type GroupTypeToggleProps = {
  isPrivate: boolean;
  setIsPrivate: Dispatch<SetStateAction<boolean>>;
};
export default function GroupTypeToggle({
  isPrivate,
  setIsPrivate,
}: GroupTypeToggleProps) {
  return (
    <ToggleButtonGroup
      size="small"
      value={isPrivate}
      exclusive
      onChange={(_, value) => setIsPrivate(!!value)}
    >
      <StyledToggleButton value={false}>
        <Typography>Public</Typography>
      </StyledToggleButton>
      <StyledToggleButton value={true}>
        <Typography>Private</Typography>
      </StyledToggleButton>
    </ToggleButtonGroup>
  );
}

const StyledToggleButton = styled(ToggleButton)<ToggleButtonProps>(() => ({
  "&.Mui-selected": {
    color: "white",
    backgroundColor: colors.coralRed,
    "&:hover": {
      backgroundColor: colors.maximumRed,
    },
  },
}));
